import React from 'react';
import { useDispatch } from 'react-redux';
import { Input, Row, Col, Space } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from "@mui/material/ButtonGroup";
import {SaveRounded, FileCopyRounded, UnfoldMoreRounded, UnfoldLessRounded,
    LightbulbRounded, TuneRounded
} from "@mui/icons-material";
import useClipboard from '../../../../hooks/useClipboard'
import {useSelector} from "react-redux";
import {setSmaMode} from "../../../../store/slices/sma.slice";

/**
 * SmaMetadata component to manage the SMA's metadata.
 * Allows users to input and update the name of the SMA.
 */
const SmaMetadata = ({ currentSmaConfig, updateConfig, handleSave, showEtfBanner, toggleEtfBanner, extra }) => {
    const dispatch = useDispatch();
    const isPublic = useSelector(state=>state.public.isPublicAccess)
    const smaMode = useSelector(state=>state.sma.mode);

  const handleNameChange = (e) => {
    const newName = e.target.value;
    updateConfig('name', newName);  // Update the name in the current SMA config
  };
  const copyToClipboard = useClipboard();
  const atLeastOneNotReplicated = Object.keys(currentSmaConfig.etfs).some(etf => currentSmaConfig.etfs[etf].doNotReplicate);
  const tickerString = Object.keys(currentSmaConfig.etfs).map(x=>`"${x}"`).join(', ');

  const toggleMode = ()=>{
      dispatch(setSmaMode(smaMode==='simple'?'advanced':'simple'))
  }


  return (
    <Row justify={'start'}>
        <Col>
            <Row justify={'start'} gutter={12}>
                <Col>
                    <Input
                          rootClassName={'primary'}
                        placeholder="Enter SMA Name"
                        value={currentSmaConfig?.name || ''}
                        onChange={handleNameChange}
                        style={{ width: '300px', marginBottom: '20px' }}
                      />
                </Col>
                <Col>
                    <ButtonGroup color={'secondary'}>
                        {!isPublic && <Button size={'small'} variant="contained" startIcon={<SaveRounded/>} onClick={handleSave}>Save</Button>}
                        <Button variant="outlined" startIcon={<FileCopyRounded/>} onClick={()=>copyToClipboard(tickerString)}>Copy Tickers</Button>
                        <Button startIcon={showEtfBanner?<UnfoldMoreRounded/>:<UnfoldLessRounded/>} onClick={toggleEtfBanner} variant={'outlined'}>{showEtfBanner ? "Collapse ETFs" : "Show All ETFs"}</Button>
                        <Button startIcon={smaMode==='simple'?<LightbulbRounded/>:<TuneRounded/>} onClick={toggleMode} variant={'outlined'}>{smaMode==='simple' ? "Simple SMA" : "Advanced SMA"}</Button>

                        {extra}

                    </ButtonGroup>
                </Col>
            </Row>
        </Col>
    </Row>
  );
};

export default SmaMetadata;
